<template>
  <v-card class="screen-height-container flex-content">
    <v-card-title>
      <h2>Welcome to Agrify Insights!</h2>
      <v-spacer />
      <r-button
        :outlined="true"
        @onclick="onClose"
        icon="close"
        color="primary"
        label="Close"
      />
    </v-card-title>
    <v-card-text>
     <video ref="myvideo" :src="baseUrl + src" :autoplay="true"  :controls="true" style="width: 100%; height: 100%;"/>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn color="primary" text @click="onAcknowledge" :loading="isLoading"
        >Don't show me this again</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Trimaster from "@/plugins/servers/trimaster.js";

export default {
  name: "IntroVideoViewer",
  props: ["src"],
  data() {
    return {
      isLoading: false,
      baseUrl: "https://help.agrifyinsights.com/assets/media/",
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  beforeMount() {},
  methods: {
    async onAcknowledge() {
      let me = this;
      me.isLoading = true;
      Trimaster.patch("users", this.getUser.apitoken, {
        id: this.getUser.id,
        showIntroVideo: false,
      }).then(function ([res, err]) {
        me.isLoading = false;
        me.onClose();
      });
    },

    onClose() {
      this.$refs.myvideo.pause();
      this.$emit("close");
    },
  },
};
</script>
<style>
</style>
